import React, {Component} from 'react';
import {Link, Redirect} from 'react-router-dom'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import Input from './components/Input';
import Button from './components/Button'
import fetchWP from './utils/fetchWP';
import Toggle from 'react-toggle';
import Modal from 'react-modal';
import ReactResponsiveSelect from 'react-responsive-select';
import moment from 'moment';
// import {DatetimePickerTrigger} from 'rc-datetime-picker';
import styled from "styled-components";
import {DateTimePicker} from '@atlaskit/datetime-picker';

//Custom Components 
import FormGroup from './components/FormGroup'
//End Custom Components 


const user_roles = [{text: 'All', value: '0'}, ...Object.keys(window.awdp_object.user_roles).map((key) => {
    return {value: key, text: window.awdp_object.user_roles[key]};
})];

// console.log(user_roles);
const caretIcon = (
    <svg className="caret-icon" x="0px" y="0px" width="11.848px" height="6.338px"
         viewBox="351.584 2118.292 11.848 6.338">
        <g>
            <path
                d="M363.311,2118.414c-0.164-0.163-0.429-0.163-0.592,0l-5.205,5.216l-5.215-5.216c-0.163-0.163-0.429-0.163-0.592,0s-0.163,0.429,0,0.592l5.501,5.501c0.082,0.082,0.184,0.123,0.296,0.123c0.103,0,0.215-0.041,0.296-0.123l5.501-5.501C363.474,2118.843,363.474,2118.577,363.311,2118.414L363.311,2118.414z"/>
        </g>
    </svg>
);

const multiSelectOptionMarkup = (text) => (
    <div>
        <span className="checkbox">
            <svg className="checkbox-icon" x="0px" y="0px" width="12px" height="12px" viewBox="0 0 488.878 488.878">
                <g><polygon
                    points="143.294,340.058 50.837,247.602 0,298.439 122.009,420.447 122.149,420.306 144.423,442.58 488.878,98.123 437.055,46.298 "/></g>
            </svg>
        </span>
        <span> {text}</span>
    </div>
);

const parseValue = (value, date, time, zone) => {
    const parsed = moment(value).parseZone();
    const returnObject = {
        dateValue: parsed.isValid() ? parsed.format('YYYY-MM-DD') : date,
        timeValue: parsed.isValid() ? parsed.format('HH:mm') : time,
        zoneValue: '+0800',
    };
    return returnObject;
};

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

const productList = window.awdp_object.productlist;

const productLists = [{text: 'All', value: '0'}];
if (productList) {
    for (var i = 0; i < productList.length; i++) {
        productLists.push({text: productList[i]['name'], value: productList[i]['id']})
    }

}

function ProductList(props) {
    const products = window.awdp_object.productlist;
    let options = [];
    if (products) {
        options.push({text: 'Select Product', value: 'null', markup: multiSelectOptionMarkup('Select Product')})
        for (var i = 0; i < products.length; i++) {
            options.push({
                text: products[i]['post_title'],
                value: products[i]['ID'],
                markup: multiSelectOptionMarkup(products[i]['post_title'])
            })
        }
        let handleChange = (value) => {
            props.onChange(value);
        }
        let value = ((Array.isArray(props.value) && props.value.length) ? props.value : ['0']);
        return (
            <ReactResponsiveSelect
                multiselect={true}
                options={options}
                caretIcon={caretIcon}
                onChange={(value) => {
                    props.onChange(value);
                }}
                selectedValues={value}/>
        );
    }
}

function CategoryList(props) {
    const cats = window.awdp_object.cats;
    let options = [];
    if (cats) {
        options.push({text: 'Select Category', value: 'null', markup: multiSelectOptionMarkup('Select Category')})
        for (var id in cats) {
            options.push({text: cats[id], value: id, markup: multiSelectOptionMarkup(cats[id])})
        }
        let handleChange = (value) => {
            props.onChange(value);
        }

        let value = ((Array.isArray(props.value) && props.value.length) ? props.value : ['0']);
        return (
            <ReactResponsiveSelect
                multiselect={true}
                options={options}
                caretIcon={caretIcon}
                onChange={(value) => {
                    props.onChange(value);
                }}
                selectedValues={value}
            />

        );
    }
}

function isEligible(value) {
    if (value !== false || value !== null || value !== 0 || value !== "") {
        return value;
    }
}

const emptyRule = {
    id: false,
    name: '',
    label: 'Discount',
    active: false,
    inc_tax: false,
    sequentially: false,
    apply_once: false,
    priority: 1,
    discount_type: '',
    discount: '',
    coupon: '',
    usage_limit: '',
    start_date: moment(),
    end_date: false,
    rules: [],
    product_list: ''
};
export default class Details extends Component {
    onChange = (model) => {
        this.setState({
            model
        });
    }

    /* This lifecycle hook gets executed when the component mounts */
    handleChangenew = (e) => {
        this.setState((prevState) => ({
            rule: {...prevState.rule, enddate: e}
        }))
    }
    handleNameChange = (evt) => {
        this.setState({name: evt.target.value});
    }
    handleShareholderNameChange = (idx) => (evt) => {
        const newShareholders = this.state.shareholders.map((shareholder, sidx) => {
            if (idx !== sidx) return shareholder;
            return {...shareholder, name: evt.target.value};
        });

        this.setState({shareholders: newShareholders});
    }
    handleAddShareholder = () => {
        this.setState({shareholders: this.state.shareholders.concat([{name: ''}])});
    }

    // handleChange = (e) => {
    //     console.log(e);
    //     this.setState(prevState => ({
    //         rule: {
    //             ...prevState.rule, startdate: e
    //         } 
    //     }));
    //     console.log(this.state.rule);
    // }
    handleRemoveShareholder = (idx) => () => {
        this.setState({shareholders: this.state.shareholders.filter((s, sidx) => idx !== sidx)});
    }
    handleStartDateChange = (e) => {
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, start_date: e
            }
        }));
    }
    handleEndDateChange = (e) => {
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, end_date: e
            }
        }));
    }

    constructor(props) {
        super(props);
        this.state = {
            'action': this.props.match.params.id == 'add' ? 'add' : 'update',
            'redirect': false,
            modalIsOpen: false,
            isHidden: true,
            discountoptions: '',
            bogocategories: false,
            name: '',
            awdpLoader: true,
            shareholders: [{name: ''}],
            rule: emptyRule
        }
        this.fetchWP = new fetchWP({
            restURL: window.awdp_object.root,
            restNonce: window.awdp_object.api_nonce,
        });
        // this.fetchWP.post('userroles').then((json) => {
        //     this.setState({
        //         opts: json
        //     });
        // });
        // this.handleTextArea = this.handleTextArea.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleModeChange = this.handleModeChange.bind(this);
        this.handleBogoChange = this.handleBogoChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleFormDeletion = this.handleFormDeletion.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        //Model
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        updateDisabled: false;
        deleteDisabled: false;
        noDisabled: false;
        yesDisabled: false;
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    afterOpenModal() {
        this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    handleRuleChange(data) {
        this.setState((prevState) => ({
            rule: {...prevState.rule, rules: data}
        }))
    }

    handleProductChange(data) {
        let options = data.options.map(e => {
            return e.value;
        });
        // this.setState((prevState) => ({
        //     data: update(this.state.products, {  products: { rule: { value: { $set: options } } } })
        // }), () => {
        //     this.props.onChange(this.state.products)
        // })
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id != prevProps.match.params.id) {
            if (this.props.match.params.id == 'add') {
                this.setState(prevState => ({
                    rule: {...prevState.rule, ...emptyRule}
                }));
            } else {
                this.fetchRule();
            }


        }
    }

    fetchRule() {
        this.setState({
            awdpLoader: true
        });
        this.fetchWP.get('rules/' + this.props.match.params.id)
            .then(
                (json) => {
                    var start_date = json.start_date + 'T' + json.start_time;
                    var end_date = json.end_date + 'T' + json.end_time;
                    this.setState(prevState => ( 
                        {
                            rule: {
                                ...prevState.rule,
                                name: json.name,
                                label: json.label,
                                id: json.id,
                                priority: json.priority,
                                discount: json.discount,
                                discount_type: json.discount_type, 
                                usage_limit: json.usage_limit,
                                product_list: json.product_list,
                                start_date: start_date,
                                end_date: end_date,
                                sequentially:  json.sequentially == 1 ? true : false,
                                apply_once:  json.sequentially == 1 ? true : false,
                                inc_tax: json.inc_tax == 1 ? true : false,
                                show_in_loop: json.show_in_loop == 1 ? true : false,
                                disable_on_sale: json.disable_on_sale == 1 ? true : false,
                                status: json.status == 1 ? true : false,
                                rules: json.rules != '' ? json.rules : []
                            },
                            awdpLoader: false
                        }
                    )); 
                }
            );
    }

    componentDidMount() {
        let title = 'Edit rule';

        if (this.props.match.params.id == 'add') {
            title = 'Add New';
            this.setState({
                awdpLoader: false
            });
        } else {
            this.fetchRule();
        }
    }

    handleInput(e) {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, [name]: value
            }
        }))
    }

    handleSelect(e) {
        let value = e.value;
        let name = e.name;
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, [name]: value
            }
        }))
    }

    handleModeChange(e) {
        let value = e.value;
        let name = e.name;

        if (value == 'discount_options' || value == 'percentage_price' || value == 'percentage_total_amount' || value == 'fixed_price' || value == 'fixed_total_amount') {
            this.setState({
                discountoptions: 'discount'
            });
        } else if (value == 'bogo') {
            this.setState({
                discountoptions: 'bogo'
            });
        } else if (value == 'bogo_x') {
            this.setState({
                discountoptions: 'bogo_x'
            });
        } else if (value == 'gift' || value == 'bulk') {
            this.setState({
                discountoptions: 'gift'
            });
        }

        this.setState(prevState => ({
            rule: {
                ...prevState.rule, [name]: value
            }
        }))
    }

    handleBogoChange(e) {
        let value = e.value;
        let name = e.name;

        if (value == 'category') {
            this.setState({
                bogocategories: true
            });
        } else {
            this.setState({
                bogocategories: false
            });
        }

        this.setState(prevState => ({
            rule: {
                ...prevState.rule, [name]: value
            }
        }))
    }

    handleStatusChange(e) {
        let value = e.target.checked;
        let name = e.target.name;
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, [name]: value, active: value
            }
        }))
    }

    handleFormSubmit(e) {
        e.preventDefault();
        if (this.state.action == 'add') {
            this.createRule();
        } else {
            this.updateRule();
        }
    }

    handleFormDeletion(e) {
        e.preventDefault();
        let ruleData = {'id': this.state.rule.id};
        this.setState({
            noDisabled: true
        });
        this.setState({
            yesDisabled: true
        });
        this.fetchWP.post('delete', ruleData)
            .then(
                (json) => {
                    window.location = json;
                    this.setState({
                        noDisabled: false,
                        yesDisabled: false
                    });
                }
            );
    }

    createRule() {
        let ruleData = this.state.rule;
        ruleData.model = this.state.model;
        this.setState({
            isHidden: false
        });
        this.fetchWP.post('rules', ruleData)
            .then(
                (json) => {
                    this.setState(prevState => ({
                        redirect: true,
                        isHidden: true,
                        rule: {...prevState.rule, id: json}
                    }))
                }
            );
    }

    updateRule() {
        let ruleData = this.state.rule;
        //console.log(ruleData);
        let sparseArray = ruleData.rules.filter(isEligible);
        if (sparseArray.length != 0) {
            for (i = 0; i < sparseArray.length; i++) {
                sparseArray[i].rules = sparseArray[i].rules.filter(isEligible);
            }
        }
        ruleData.rules = sparseArray.filter(isEligible);

        this.setState({
            isHidden: false,
            updateDisabled: true,
            deleteDisabled: true
        });

        this.fetchWP.post('rules', ruleData)
            .then(
                (json) => {
                    this.setState({
                        isHidden: true,
                        updateDisabled: false,
                        deleteDisabled: false
                    });
                }
            );
    }

    render() {
        const buttonStyle = {
            margin: '10px 10px 10px 10px'
        }
        const hideButton = {
            display: 'none'
        }
        const AWRPLoader = () => (
            <div className="awdp_loader"></div>
        );
        const AWRPStatus = () => (
            <div class="awpr_update_text">Saving Changes...</div>
        );
        return (
            <div className="awdp_detail clearfix">
                {this.state.awdpLoader != false ?
                    <div className="awdp_loader"></div>
                    : ''}
                {this.state.redirect ? <Redirect to={'/rule/' + this.state.rule.id}/> : ''}
                <div className="awdp_detail_top">
                    {/* <Link className="awdp_back_button" to={
                        '/'}></Link> */}
                    {/* <h1>{this.state.rule.name}</h1> */}
                    {/* Redirect: {this.state.redirect} */}
                    <h4>Allo Good day !!</h4>
                    <p>Setting the discount rate is easy. Just play with the below settings and watch the changes</p>
                </div>
                {!this.state.isHidden && <AWRPStatus/>}
                <Tabs>
                    <TabList>
                        <Tab>Discount Settings</Tab>
                        <Tab>Schedule</Tab>
                        <Tab>Rules and Restrictions</Tab>
                    </TabList>
                    <TabPanel>
                        <div className="awdp_field_group">
                            <Input inputType={'text'}
                                   title={'Rule Name'}
                                   name={'name'}
                                   value={this.state.rule.name}
                                   placeholder={'Enter rule name'}
                                   handleChange={this.handleInput}/>
                            <Input inputType={'text'}
                                   title={'Discount Label'}
                                   name={'label'}
                                   value={this.state.rule.label}
                                   placeholder={'Enter Discount Label'}
                                   handleChange={this.handleInput}/>
                            <div className="form-group">

                                <div className="sub-group">
                                    <Input inputType={'number'}
                                           title={'Priority'}
                                           name={'priority'}
                                           value={this.state.rule.priority}
                                           placeholder={'Enter discount priority'}
                                           handleChange={this.handleInput}/>
                                </div>
                                <div className="sub-group">
                                    <label className="form-label">Active</label>
                                    <Toggle
                                        name={'status'}
                                        icons={false}
                                        value={this.state.rule.status}
                                        checked={this.state.rule.status}
                                        onChange={this.handleStatusChange}/>
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="form-label">Product Lists</label>
                                <ReactResponsiveSelect
                                    name={'product_list'}
                                    options={productLists}
                                    caretIcon={caretIcon}
                                    noSelectionLabel={'Select Product List'}
                                    onChange={this.handleSelect}
                                    selectedValue={this.state.rule.product_list}/>
                            </div>
                            <div className="form-group"> { console.log(this.state.rule.discount_type) }
                                <label className="form-label">Discount Type</label>
                                <ReactResponsiveSelect
                                    name={'discount_type'}
                                    options={[
                                        {text: 'Percentage of cart total amount', value: 'percent_total_amount'},
                                        {text: 'Percentage of product price', value: 'percent_product_price'},
                                        {text: 'Fixed price of product price', value: 'fixed_product_price'},
                                        {text: 'Fixed price of cart total amount', value: 'fixed_cart_amount'},
                                        // { text: 'Buy One Get One', value:'bogo'},
                                        // { text: 'Buy X Get X', value:'bogo_x'},
                                        // { text: 'Gift Product', value:'gift'}
                                    ]}
                                    onChange={this.handleModeChange}
                                    caretIcon={caretIcon}
                                    selectedValue={this.state.rule.discount_type}/>
                            </div>
                            <div>
                                <div className="form-group">
                                    <div className="sub-group">
                                        <Input inputType={'number'}
                                               title={'Discount Value'}
                                               name={'discount'}
                                               value={this.state.rule.discount}
                                               placeholder={'Discount percentage / amount'}
                                               handleChange={this.handleInput}/>
                                    </div>
                                    <div className="sub-group">
                                        <label className="form-label">Including Tax</label>
                                        <Toggle
                                            name={'inc_tax'}
                                            icons={false}
                                            value={this.state.rule.inc_tax}
                                            checked={this.state.rule.inc_tax}
                                            onChange={this.handleStatusChange}/>

                                    </div>

                                </div>
                                {(this.state.rule.discount_type=='percent_total_amount' || this.state.rule.discount_type=='percent_product_price')?
                                <div className="form-group">
                                    <label className="form-label">Apply sequentially (When applying multiple discounts, apply the first discount to the full price and the second discount to the discounted price and so on.) </label>
                                    <Toggle
                                        name={'sequentially'}
                                        icons={false}
                                        value={this.state.rule.sequentially}
                                        checked={this.state.rule.sequentially}
                                        onChange={this.handleStatusChange}/>
                                </div>
                                :''}

                            </div>
                        </div>

                        {this.state.discountoptions == 'bogo' ?
                            <div className="awdp_field_group">
                                <div className="awdp_discount_desc">
                                    <h3>BUY ONE GET ONE OPTIONS</h3>
                                    <p></p>
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Discount Action</label>
                                    <ReactResponsiveSelect
                                        name={'discount_bogo_action'}
                                        options={[
                                            {text: 'Buy something discount next item', value: 'next_item'},
                                            {text: 'Buy something discount selected item', value: 'selected_item'},
                                        ]}
                                        caretIcon={caretIcon}
                                        noSelectionLabel={'Select Discount Action'}
                                        onChange={this.handleSelect}
                                        selectedValue={this.state.rule.discount_bogo_action}/>
                                </div>
                                <div className="form-group">
                                    <div className="sub-group">
                                        <label className="form-label">Products</label>
                                        <ProductList value={this.state.rule.products}
                                                     onChange={(data) => {
                                                         this.handleProductChange(data);
                                                     }}/>
                                    </div>
                                </div>
                            </div>
                            : this.state.discountoptions == 'bogo_x' ?
                                <div className="awdp_field_group">
                                    <div className="awdp_discount_desc">
                                        <h3>BUY X GET X OPTIONS</h3>
                                        <p></p>
                                    </div>
                                    <div className="form-group">
                                        <div className="sub-group">
                                            <label className="form-label">Type</label>
                                            <ReactResponsiveSelect
                                                name={'bogo_mode'}
                                                options={[
                                                    {text: 'Specific Category', value: 'category'},
                                                    {text: 'Specific Products', value: 'products'}
                                                ]}
                                                caretIcon={caretIcon}
                                                noSelectionLabel={'Select One'}
                                                onChange={this.handleBogoChange}
                                                selectedValue={this.state.rule.bogo_mode}/>
                                        </div>

                                        {this.state.bogocategories == true ?
                                            <div className="sub-group">
                                                <label className="form-label">Categories</label>
                                                <CategoryList value={this.state.rule.products}
                                                              onChange={(data) => {
                                                                  this.handleProductChange(data);
                                                              }}/>
                                            </div>
                                            :
                                            <div className="sub-group">
                                                <label className="form-label">Products</label>
                                                <ProductList value={this.state.rule.products}
                                                             onChange={(data) => {
                                                                 this.handleProductChange(data);
                                                             }}/>
                                            </div>
                                        }
                                    </div>
                                    <div className="form-group">
                                        <div className="sub-group">
                                            <Input inputType={'number'}
                                                   title={'Min Quantity'}
                                                   name={'min_quantity'}
                                                   value={this.state.rule.min_quantity}
                                                   placeholder={'Set Min Quantity'}
                                                   handleChange={this.handleInput}/>
                                        </div>
                                        <div className="sub-group">
                                            <Input inputType={'number'}
                                                   title={'Max Quantity'}
                                                   name={'max_quantity'}
                                                   value={this.state.rule.max_quantity}
                                                   placeholder={'Set Max Quantity'}
                                                   handleChange={this.handleInput}/>
                                        </div>
                                    </div>
                                </div>
                                : this.state.discountoptions == 'gift' ?
                                    <div className="awdp_field_group">
                                        <div className="awdp_discount_desc">
                                            <h3>GIFT OPTIONS</h3>
                                            <p></p>
                                        </div>
                                        <div className="form-group">
                                            <p>Gifts based on no of items in cart</p>
                                            <p>Gifts based on cart amount</p>
                                            <p>Product specific gifts</p>
                                            <p>Gift for any product added in the cart</p>
                                        </div>
                                    </div>
                                    : ''

                        }
                        {/* <div className="form-group">
                            <label className="form-label">Disable Coupon</label>
                            <Toggle
                                name={'coupon'}
                                icons={false}
                                value={this.state.rule.coupon}
                                checked={this.state.rule.coupon}
                                onChange={this.handleStatusChange} />
                        </div> */}
                        <div className="form-group">
                            <label className="form-label">Disable discount if product is on sale</label>
                            <Toggle
                                name={'disable_on_sale'}
                                icons={false}
                                value={this.state.rule.disable_on_sale}
                                checked={this.state.rule.disable_on_sale}
                                onChange={this.handleStatusChange}/>
                            {/*<label className="form-label">Dont apply if other discounts applied</label>*/}
                            {/*<Toggle*/}
                                {/*name={'Usage Limit'}*/}
                                {/*icons={false}*/}
                                {/*value={this.state.rule.apply_once}*/}
                                {/*checked={this.state.rule.apply_once}*/}
                                {/*onChange={this.handleStatusChange}/>*/}
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="form-group">
                            <label className="form-label">Discount Schedule from</label>
                            <DateTimePicker
                                id="start_date"
                                defaultValue={this.state.rule.start_date}
                                value={this.state.rule.start_date}
                                name="startdate"
                                parseValue={parseValue}
                                onChange={this.handleStartDateChange}/>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Discount Schedule to</label>
                            <DateTimePicker
                                id="end_date"
                                defaultValue={this.state.rule.end_date}
                                value={this.state.rule.end_date}
                                name="enddate"
                                parseValue={parseValue}
                                onChange={this.handleEndDateChange}/>
                        </div>
                    </TabPanel>
                    <TabPanel>

                        <div className="awdp_field_group">
                            <div className="awdp_discount_desc">
                                <h3>Apply Rules</h3>
                                <p>You can set discount rule using the provided options</p>
                            </div>
                            <div className="form-group">
                                <FormGroup rules={this.state.rule.rules}
                                           onChange={(data) => {
                                               this.handleRuleChange(data);
                                           }}/>
                            </div>
                        </div>

                        {/*<Input inputType={'number'}*/}
                               {/*title={'Usage Limit'}*/}
                               {/*name={'usage_limit'}*/}
                               {/*value={this.state.rule.usage_limit}*/}
                               {/*placeholder={'Set Usage Limit'}*/}
                               {/*handleChange={this.handleInput}/>*/}

                        {/*<div className="form-group">*/}
                        {/*<label className="form-label">User Role</label>*/}
                        {/*<ReactResponsiveSelect*/}
                        {/*name={'userrole'}*/}
                        {/*options={user_roles}*/}
                        {/*caretIcon={caretIcon}*/}
                        {/*noSelectionLabel={'Select User Role'}*/}
                        {/*onChange={this.handleSelect}*/}
                        {/*selectedValue={this.state.rule.userrole} /> */}
                        {/*</div> */}
                        {/*<Input inputType={'number'}*/}
                        {/*title={'Users Limit'}*/}
                        {/*name={'users_limit'}*/}
                        {/*value={this.state.rule.users_limit}*/}
                        {/*placeholder={'Set Users Limit'}*/}
                        {/*handleChange={this.handleInput} />*/}
                    </TabPanel>
                </Tabs>
                <div className="save_changes">
                    <Button action={
                        this.openModal}
                            type={'secondary'}
                            title={'Delete'}
                            style={this.props.match.params.id == 'add' ? hideButton : buttonStyle}
                            disabled={this.state.deleteDisabled}/>
                    <Button action={
                        this.handleFormSubmit}
                            type={'primary'}
                            title={this.props.match.params.id == 'add' ? 'Publish' : 'Update'}
                            style={buttonStyle}
                            disabled={this.state.updateDisabled}/>
                    {!this.state.isHidden && <AWRPLoader/>}
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeModal}
                        style={customStyles}
                        contentLabel="Delete">
                        <h2 ref={subtitle => this.subtitle = subtitle}>All discount related datas will be removed.</h2>
                        <h4 ref={subtitle => this.subtitle = subtitle}>Are you sure to proceed?</h4>
                        <Button action={
                            this.closeModal}
                                type={'primary'}
                                title={'No'}
                                style={buttonStyle}
                                disabled={this.state.noDisabled}/>
                        <Button action={
                            this.handleFormDeletion}
                                type={'secondary'}
                                title={'Yes'}
                                style={buttonStyle}
                                disabled={this.state.yesDisabled}/>
                    </Modal>
                </div>
            </div>
        )
    }
}